import {styled} from '@mui/material/styles';
import {MenuItem} from '@mui/material';
import {typography} from "../../theme"

const CustomMenuItem = styled(MenuItem)(({theme}) => ({
    fontFamily: 'Poppins',
    fontSize: typography.body.fontSize
}));

export {CustomMenuItem};